
import { Vue, Component, Prop } from 'vue-property-decorator';
import appIcons from '@/plugins/vuetify/icons';

@Component
export default class Icon extends Vue {
  @Prop(Boolean)
  large?: boolean;

  @Prop(Boolean)
  outline?: boolean;

  @Prop({
    required: true,
    validator(value: string): boolean {
      let isIcon = false;

      for (let icon in appIcons) {
        // Check if prop icon name exists in the list of all icons
        // We only check the name before words -fill and -outline
        if (icon.match(/.+?(?=-small|-large)/g)![0] === value) {
          isIcon = !isIcon;
          break;
        }
      }

      return isIcon;
    },
  })
  name!: string;

  get getSize(): string {
    return this.large ? 'large' : 'small';
  }

  get getType(): string {
    return this.outline ? 'outline' : 'fill';
  }
}
